import { createSelector } from "@reduxjs/toolkit";

import { dataSelector } from "./helpers";
import { IDataKeys } from "shared/types";
import { buildData } from "Bands/state";
import { IBandCustomSubscriptionRequest } from "Bands/types";

export const customSubscriptionRequestsSelector = createSelector(
  dataSelector,
  (data) =>
    (buildData(data as any, IDataKeys.customSubscriptionRequest) ||
      []) as IBandCustomSubscriptionRequest[]
);
